import { mapState, mapActions } from "vuex";
import { getArcGISBasemap } from "./basemapLogic";
import Vue from "vue";
import { loadModules } from "esri-loader";

const basemapMixin = {
  data: function() {
    return {};
  },
  computed: {
    ...mapState(["profiles", "selectedBasemap"])
  },
  methods: {
    ...mapActions(["setSelectedBasemap"]),
    setBasemap(basemap) {
      return new Promise((resolve, reject) => {
        Vue.$cookies.set("basemap", basemap);

        if (basemap.useProxy) {
          this.addProxyRule({ serviceUrl: basemap.options.url });
        }
        getArcGISBasemap(basemap)
          .then(arcgisBasemap => {
            this.setSelectedBasemap({
              basemap: basemap,
              loadedBasemap: arcgisBasemap
            });
            resolve(arcgisBasemap);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    addProxyRule(profile) {
      loadModules(["esri/core/urlUtils"]).then(([urlUtils]) => {
        let proxyUrl = "";
        if (
          profile.hasOwnProperty("OnlyAccessibleViaIntranet") &&
          profile.OnlyAccessibleViaIntranet
        ) {
          proxyUrl = process.env.VUE_APP_INTERNAL_PROXY_URL;
        } else {
          proxyUrl = process.env.VUE_APP_PROXY_URL;
        }
        urlUtils.addProxyRule({
          urlPrefix: profile.serviceUrl,
          proxyUrl: proxyUrl
        });
      });
    }
  }
};

export default basemapMixin;
